module.exports = __webpack_public_path__ + "img/programaBecas.ec57130c.png";